import React from 'react';

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'li';
}

/**
 * A grouping wrapper, nothing more. It used to fade its children in on first
 * scroll into view; that was removed because the guidelines ask for no
 * entrance motion and content gated on an observer is invisible to print,
 * full-page captures and any browser where the observer never fires.
 */
export default function Reveal({ children, className = '', as: Tag = 'div' }: RevealProps) {
  return <Tag className={`mk-reveal ${className}`.trim()}>{children}</Tag>;
}
